module.exports = __webpack_public_path__ + "img/1.d89e56bc.png";